import React from 'react';
import { resetUserData } from "../../services/auth";
import { Button } from "components/ui/button";
import { useHistory } from "react-router-dom";
import { PAGES } from "../../routes/PAGES";
import { useCommunity, useCurrentUser } from "../../context/community";
import LangService from "../../services/LangService";
import { markTelegramManualLoginIntent } from "../../services/telegramStartParam";

const SHOULD_LOGIN_BE_HIDDEN = [PAGES.LOGIN, PAGES.REGISTRATION, PAGES.RECOVERY, PAGES.CONFIRM_RECOVERY,
PAGES.CONFIRMED, PAGES.AUTH_MAGIC];

const LoginButton = () => {
    const history = useHistory();
    const { resetData } = useCommunity();
    const { userId } = useCurrentUser();
    const textMap = LangService.map.components.logout
    const onButtonClick = () => {
        gtag("event", "to_login_page");
        if (userId) {
            gtag("event", "logout");
            // Leave the page you signed out from behind. It is not a deeplink.
            sessionStorage.removeItem('redirectToAfterLogin');
            resetUserData();
            resetData();
        }
        markTelegramManualLoginIntent();
        history.push(PAGES.LOGIN);
    }

    const isLoginHidden = SHOULD_LOGIN_BE_HIDDEN.includes(history.location.pathname);

    if (isLoginHidden) return null;

    return (
        <Button type="button" onClick={onButtonClick}>
            {userId ? textMap.out : textMap.in}
        </Button>
    );
};

export default LoginButton;
